import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getCompanyCnpjs(companyId) {
  try {
    const { data } = await authHttp().get(routes.urlCompanyCnpjs(companyId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveCompanyCnpj(companyId, cnpj) {
  try {
    const { data } = await authHttp().post(routes.urlPostCompanyCnpj(companyId), { cnpj })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteCompanyCnpj(companyId, id) {
  try {
    const { data } = await authHttp().delete(routes.urlDeleteCompanyCnpj(companyId, id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
